"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditSummary = CreditSummary;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const moment_1 = __importDefault(require("moment"));
const styled_components_1 = __importDefault(require("styled-components"));
const useConfig_1 = require("@src/hooks/useConfig");
const CreditSummaryContainer = styled_components_1.default.div `
	margin-top: 3rem;
	text-align: center;

	& > p {
		color: ${({ theme }) => theme.color.gray6};
	}
`;
function CreditSummary({ deadline }) {
    const config = (0, useConfig_1.useConfig)();
    const numberOfCreditsUsed = deadline ? Math.ceil(deadline.diff((0, moment_1.default)(), 'days') / config.daysForOneCredit) : 1;
    return ((0, jsx_runtime_1.jsx)("div", { className: "m-t-m", children: (0, jsx_runtime_1.jsxs)(CreditSummaryContainer, { children: [(0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.offer_form.offer_active_days", values: { days: (deadline === null || deadline === void 0 ? void 0 : deadline.diff((0, moment_1.default)(), 'days')) || 1 } }) }), (0, jsx_runtime_1.jsx)("h2", { className: "m-b-s", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.offer_form.credit_summary", values: {
                            credits: numberOfCreditsUsed || 1,
                            b: chunks => (0, jsx_runtime_1.jsxs)("b", { children: [...chunks] }),
                        } }) }), (0, jsx_runtime_1.jsx)("p", { className: "m-none", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.offer_form.credit_deadline_calculation" }) })] }) }));
}
